export default __webpack_public_path__ + "static/media/brown-connie-passionate-kiss.1b7913d7.png";